module.exports = __webpack_public_path__ + "media/images/auth_2-f6fe9e7055c48e1b62eb0569f9278d70.jpg";